<template>
  <Modal @close="localClose" :wide="false" normal-width="90vw" width="960px" set-class="no-padding">
    <div slot="header">
      <div class="modal-header">
        <div class="heading">
        </div>
      </div>
    </div>
    <div class="modal-content">
      <Loading :show="loading" />

      <div class="h1">
        <h1>Din bokning: {{order.resvid}}</h1>
      </div>

      <div v-if="!onlyMore">
        <div class="container" style="text-align:center;" v-if="showQrCodeButton">
          <button @click="openQrModal" class="button">Visa QR-koder till liftkortsautomat</button>
        </div>

        <div class="info" style="text-align:center;" v-if="(order && order.pickups ? order.pickups : []).length > 1 && SITE_CONFIG.site === 'branas'">
          <p><b>OBS!</b> Du har flera utlämningsställen valda för din bokning ({{ order.pickups.join(', ') }}). Kontakta gästservice på <a href="tel:054-13 26 00">054-13 26 00</a> om du vill ändra.</p>
        </div>

        <div class="container" :class="{disabled: loading}">

          <Cart @loading="loading = true" @loadingcomplete="loading = false" @changed="reloadParent();fetch()" :use-storage="false" :order="order" :show-from-start="true" />

        </div>

        <p>&nbsp;</p>
      </div>

      <div v-if="false && !loading && order.can_add_to_booking">
        <h2>Komplettera din bokning:</h2>

        <div class="info" style="width:100%;">
          <div v-if="!onlyMore">
            För att boka tillägg till din boendebokning, såsom städ, linne eller matpåsar, välj ”Boka tillval” ovan.
            <br>
            <br>
          </div>
          Du kan bara komplettera din bokning med bokningar inom samma datum som din grundbokning.
        </div>

        <div v-if="SITE_CONFIG.add_to_booking_open">
          <CompletedBookings :add="true" :order-number="order.resvid" :order-number-numeric="order.headlid" :date-start="order.dateStart" :date-end="order.dateEnd" :helper-pool="order.firstAccomodationPoolLid" :helper-unit="order.firstAccomodationUnitLid" />
        </div>

        <div v-if="!SITE_CONFIG.add_to_booking_open">
          <p style="margin-top: 10px;">Vid ändringar eller tillägg av din bokning, vänligen ring gästservice på <a href="tel:054-13 26 00">054-13 26 00</a>.</p>
        </div>
      </div>


    </div>
  </Modal>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';

import Cart from '@/components/parts/Cart';
import Timeline from '@/components/components/Timeline';
import CompletedBookings from '@/components/parts/CompletedBookings';
import Modal from '@/components/components/Modal';
import Loading from '@/components/components/Loading';

import API from '@/classes/API';

export default {
  components: {
    Cart,
    Timeline,
    CompletedBookings,
    Modal,
    Loading,
  },
  data() {
    return {
      loading: false,
      order: {},
    };
  },
  computed: {
    ...mapGetters([
      'loggedIn',
    ]),
    showQrCodeButton() {
      if (this.loading) {
        return false;
      }

      if (!this.order) {
        return false;
      }

      if (!this.order.qrCodes) {
        return false;
      }

      if (this.order.qrCodes.length === 0) {
        return false;
      }

      return true;
    },
    onlyMore() {
      return this.$route.params.onlyMore;
    },
  },
  methods: {
    ...mapMutations([
      'openModal',
      'closeModal',
    ]),
    reloadParent() {
      this.$emit('reload', true);
    },
    async fetch() {
      this.loading = true;
      const { data } = await API.get(`/order/${this.$route.params.bookingNumber}`);
      this.order = data;
      this.loading = false;
    },
    localClose() {
      if (this.$route.query.flow) {
        const flowUri = decodeURI(this.$route.query.flow);
        this.$router.replace({ path: flowUri });
        return;
      }

      if (this.$route.name === 'my booking') {
        this.$router.replace({ name: 'my pages bookings' });
      } else {
        this.$router.replace({ name: 'my pages journey' });
      }
    },
    openQrModal() {
      this.openModal([
        'QrModal', {
          order: this.order,
        },
      ]);
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

.modal-content
  position relative

.disabled
  disabled()

.info
  info-box()
  display: inline-block;
  width auto
  margin 10px auto 0 auto
  font-size 16px
  padding 1em 2em

.h1
  text-align center
  //position absolute
  //top -61px
  //width 100%
  //left: 0;
  //&.has-subtitle
    //top: -79px
  h1
    united-heavy();
    font-size: 23px;
    text-align: center;
    color: #1c1c1c;
    margin 0 auto
    margin-top 1rem
    margin-bottom 1rem
    display inline-block
    background-color: #ffffff;
    border-radius: 5px 5px 0 0;
    padding 15px 28px 6px

.container
  padding-top 10px
  max-width 1600px
  width 100%
  margin-right auto
  margin-left auto
  position relative

.bg-color-faded
  padding-top 8px
  padding-bottom 15px
  background-color #fbfbf8
</style>



// WEBPACK FOOTER //
// MyBooking.vue?393c1eba